import { get, post } from '../../app/services/http';

let stripe;
let elements;
let card;
const style = {
  base: {
    color: 'primary',
    fontWeight: 500,
    fontFamily: 'Inter UI, Open Sans, Segoe UI, sans-serif',
    fontSize: '16px',
    fontSmoothing: 'antialiased',

    '::placeholder': {
      color: 'primary',
    },
  },
  invalid: {
    color: 'alert',
  },
};

export function instantiateStripe(Stripe, { stripePublicKey, stripeAccountId }) {
  stripe = Stripe(stripePublicKey, { stripeAccount: stripeAccountId });
  elements = stripe.elements({
    locale: 'auto',
  });
}


export function instantiateStripePlatform(Stripe, { stripePublicKey }) {
  const stripe = Stripe(stripePublicKey);
  const elements = stripe.elements({
    locale: 'auto',
  });

  return {stripe, elements};

}

export function mountCard(id) {
  card = elements.create('card', {
    hidePostalCode: true,
    style,
  });
  card.mount(id);
  return card;
}

export async function pay(orderId) {
  const url = '/rest/v1/payments/pay';
  const headers = { 'Content-Type': 'application/json' };
  const body = { orderId };
  return post({
    url,
    headers,
    body,
  });
}

export async function confirmSecretDeferred(clientSecret, paymentMethod) {
  return stripe.confirmCardPayment(clientSecret, {
    payment_method: paymentMethod,
  }, {
    handleActions: false,
  });
}

export async function confirmSecretWithNoPaymentMethod(clientSecret) {
  return stripe.confirmCardPayment(clientSecret);
}

export async function confirmSecret(clientSecret, paymentMethod = {card}) {
  return stripe.confirmCardPayment(clientSecret, {
    payment_method: paymentMethod ,
  });
}

export async function confirmSetupCardSecret(clientSecret, paymentMethod) {
  return stripe.confirmCardSetup(clientSecret, {
    payment_method: paymentMethod,
  });
}

export async function confirmPaymentRequestSecret(clientSecret, paymentMethod) {
  return stripe.confirmCardPayment(
    clientSecret,
    { payment_method: paymentMethod },
  );
}

export async function confirmSetupPaymentRequestSecret(clientSecret, paymentMethod) {
  return stripe.confirmCardSetup(
    clientSecret,
    { payment_method: paymentMethod },
  );
}

export async function confirmPayment(paymentIntentId, orderId) {
  const url = '/rest/v1/payments/post-pay';
  const headers = { 'Content-Type': 'application/json' };
  const body = {
    paymentIntentId,
    orderId,
  };
  return post({
    url,
    headers,
    body,
  });
}

export async function confirmSubscription(subscriptionId, paymentIntentId, orderId) {
  const url = '/rest/v1/payments/post-subscribe';
  const headers = { 'Content-Type': 'application/json' };
  const body = {
    subscriptionId,
    paymentIntentId,
    orderId,
  };
  return post({
    url,
    headers,
    body,
  });
}

export function mountPaymentRequestsButton(paymentRequest) {
  return elements.create('paymentRequestButton', {
    paymentRequest,
  });
}

export function createPaymentRequest({
  country, currency, total, displayItems,
}) {
  return stripe.paymentRequest({
    requestPayerName: true,
    country,
    currency: currency.toLowerCase(),
    total,
  });
}


export function mountPaymentRequestsButtonPlatform(paymentRequest, elements) {
  return elements.create('paymentRequestButton', {
    paymentRequest,
  });
}

export function createPaymentRequestPlatform({
  country, currency, total, displayItems,
}, stripe) {
  return stripe.paymentRequest({
    requestPayerName: true,
    country,
    currency: currency.toLowerCase(),
    total,
  });
}


export function createPaymentMethod(name) {
  return stripe.createPaymentMethod({
    type: 'card',
    card,
    billing_details: {
      name,
    },
  });
}

export async function subscribe(id, orderId) {
  const url = '/rest/v1/payments/subscribe';
  const headers = { 'Content-Type': 'application/json' };
  const body = {
    paymentMethodId: id,
    orderId,
  };
  return post({
    url,
    headers,
    body,
  });
}


export async function getPaymentMethods() {
  const url = '/rest/v1/payments/payment-methods';
  const headers = { 'Content-Type': 'application/json' };
  return get({
    url,
    headers,
  });
}

export async function attachPaymentMethod(id) {
  const url = '/rest/v1/payments/create-payment-method';
  const headers = { 'Content-Type': 'application/json' };
  const body = {
    paymentMethodId: id,
  };
  return post({
    url,
    headers,
    body,
  });
}
